import { render, staticRenderFns } from "./clubView.vue?vue&type=template&id=0f00423d"
import script from "./clubView.vue?vue&type=script&lang=js"
export * from "./clubView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports